import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegexUtil } from 'src/app/helpers/regex.helper';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';

@Component({
  selector: 'app-verification-init',
  templateUrl: './verification-init.component.html',
  styleUrls: ['./verification-init.component.scss'],
})
export class VerificationInitComponent implements OnInit {
  requestId: string = '';
  errorType: string = '';
  backButtonOptions: any = {
    text: 'BACK',
    color: '',
  };
  backToLoginButtonOptions: any = {
    text: 'BACK_TO_LOGIN',
    color: 'accent',
  };
  verificationPending: boolean = false;
  sub: string = '';
  provider: string = '';
  processingType: string = '';
  verificationMethods: any = [];
  verificationTypes = ['EMAIL', 'MOBILE'];
  verificationMedium: string = '';
  showVerificationList: boolean = true;
  initiateVerificationPayload: any = {};
  proceedButtonOption: any = {
    text: 'PROCEED',
    color: 'accent',
  };
  resendButtonOptn: any = {
    text: 'VERIFICATION_INIT.RESEND_CODE',
    color: 'accent',
  };
  inputOption = {
    mobile: {
      label: 'VERIFICATION_INIT.ENTER_MOBILE_PROMPT',
      placeholder: 'VERIFICATION_INIT.ENTER_MOBILE_PROMPT',
      type: 'input',
      hint: '',
      value: '',
    },
    email: {
      label: 'VERIFICATION_INIT.ENTER_EMAIL_PROMPT',
      placeholder: 'VERIFICATION_INIT.ENTER_EMAIL_PROMPT',
      type: 'input',
      hint: '',
      value: '',
    },
  };
  errorMsg!: string;
  pageLoading: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cidaasService: CidaasService,
    public commonFunc: CommonFunctionsService,
    private regex: RegexUtil,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.requestId = params.requestId || params.requestid;
      this.errorType = params.error;
      this.sub = params.sub;
      this.processingType = params.verificationType;
      this.verificationMedium = params.verificationMedium;
      this.provider = params.provider;
    });

    // show pending verification page
    if (this.errorType === 'user_not_verified') {
      this.verificationPending = true;
    } else if (
      this.errorType === 'email_in_body_must_not_be_empty' ||
      this.errorType === 'mobile_in_body_must_not_be_empty' ||
      this.errorType === 'user_already_exists'
    ) {
      this.processingType = 'CODE';
      this.showVerificationList = false;
      this.initiateVerificationPayload.verificationMedium = this.verificationMedium;
      if (this.errorType === 'user_already_exists') {
        this.errorMsg = 'USER_EXISTS';
      }
    } else if
      (this.errorType === 'email_not_verified' || this.errorType === 'mobile_number_not_verified' || this.processingType === undefined) {
      this.processingType = 'CODE';
    }
    if (this.processingType === 'CODE') {
      this.getCommunicationStatus();
    }
  }

  // get list of verification methods
  getCommunicationStatus(): void {
    this.pageLoading = true;
    this.cidaasService
      .getCommunicationStatus({
        sub: this.sub,
        provider: this.provider,
        requestId: this.requestId,
      })
      .then((data) => {
        this.pageLoading = false;
        if (data && data.success && data.data) {
          this.verificationTypes.forEach((ele) => {
            if (data.data[ele] === false) {
              if (ele === 'MOBILE') {
                this.verificationMethods.push('SMS', 'IVR');
              } else {
                this.verificationMethods.push(ele);
              }
            }
          });

          // call initiate when only email is present
          if (this.verificationMethods.length === 1 && this.verificationMethods[0] === 'EMAIL') {
            this.clickMethod(this.verificationMethods[0]);
          }
        }
      })
      .catch((e) => {
        this.errorMsg = e;
      });
  }

  // when method clicked from list, send type, populate payload and call initiate
  clickMethod(type): void {
    this.initiateVerificationPayload = {
      processingType: this.processingType,
      requestId: this.requestId,
      sub: this.sub,
      verificationMedium: type.toLowerCase(),
    };
    this.callInitiateVerification();
  }

  // call initiate account verification method
  callInitiateVerification(): void {
    this.pageLoading = true;
    this.cidaasService.initiateAccountVerification(this.initiateVerificationPayload);
  }

  // setting code from input component
  setCode(event: string, type: string) {
    let isValidInput = false;
    let re: RegExp;
    switch (type) {
      case 'email':
        re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        break;
      case 'mobile':
        re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
        break;
      default:
        re = RegExp('');
        break;
    }
    if (!!re) {
      isValidInput = re.test(event);
    }
    if (isValidInput) {
      this.inputOption[type].hint = '';
      event.replace(/\s+/g, '');
      this.inputOption[type].value = event;
    } else {
      this.inputOption[type].hint = 'The ' + type[0].toUpperCase() + type.slice(1) + ' is invalid!';
    }
  }

  // send mobile or email based on verification method
  sendVerificationMedium() {
    if (this.initiateVerificationPayload.verificationMedium === 'email') {
      this.initiateVerificationPayload.email = this.inputOption.email.value;
      let emailRegex = this.regex.email;
      if (emailRegex.test(this.inputOption.email.value)) {
        this.populatePayloadandcallInitiate();
      } else {
        this.errorMsg = 'ENTER_VALID_EMAIL';
      }
    } else {
      this.initiateVerificationPayload.mobile = this.inputOption.mobile.value;
      let mobileRegx = this.regex.mobile;
      if (mobileRegx.test(this.inputOption.mobile.value)) {
        this.populatePayloadandcallInitiate();
      } else {
        this.errorMsg = 'ENTER_VALID_MOBILE';
      }
    }
  }

  populatePayloadandcallInitiate() {
    this.initiateVerificationPayload.processingType = this.processingType;
    this.initiateVerificationPayload.requestId = this.requestId;
    this.initiateVerificationPayload.sub = this.sub;
    this.callInitiateVerification();
  }
}
